var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component__character-avatar",style:(("background-color:" + _vm.color + "; width: " + _vm.size + "; height: " + _vm.size + "; line-height: " + _vm.size + ";"))},[_vm._v("\n  "+_vm._s(_vm.char)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96ab7296","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/av_character.vue
// module id = tMzA
// module chunks = 1